import { Lock } from "lucide-react";
import { Reveal } from "./Reveal";

export const CASE_STUDY_PLACEHOLDERS = [
  { title: "Hajj Lead Generation", tag: "Paid Acquisition" },
  { title: "Umrah Lead Generation", tag: "WhatsApp-First Funnel" },
  { title: "Full-Funnel Acquisition", tag: "Multi-Channel Strategy" },
];

export const CaseStudyGrid = () => {
  return (
    <div className="grid md:grid-cols-3 gap-6">
      {CASE_STUDY_PLACEHOLDERS.map((cs, i) => (
        <Reveal key={cs.title} delay={i * 0.1} className="h-full">
          <div
            className="h-full bg-white border border-charcoal/10 overflow-hidden group"
            data-testid={`case-study-placeholder-${i + 1}`}
          >
            <div className="relative h-52 bg-cream-dark geo-pattern overflow-hidden">
              <div className="absolute -top-10 -right-10 w-44 h-44 rounded-full bg-tan/30 blur-2xl transition-transform duration-700 group-hover:scale-125" />
              <div className="absolute bottom-0 left-0 w-32 h-32 rounded-full bg-gold/25 blur-2xl" />
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="flex h-12 w-12 items-center justify-center border border-gold/50 bg-cream/80">
                  <Lock size={18} strokeWidth={1.5} className="text-tan" />
                </div>
              </div>
              <div className="absolute top-4 left-4 text-[10px] font-semibold tracking-[0.25em] uppercase text-charcoal/50">
                {"Coming Soon"}
              </div>
            </div>
            <div className="p-7">
              <div className="text-xs font-semibold tracking-[0.2em] uppercase text-tan">
                {cs.tag}
              </div>
              <h3 className="mt-3 text-xl font-semibold tracking-tight text-charcoal">
                {cs.title}
              </h3>
              <p className="mt-3 inline-block border border-gold/40 bg-cream px-3 py-1.5 text-[11px] font-semibold tracking-wide text-charcoal/60">
                {"Placeholder: Replace With Verified Client Data"}
              </p>
            </div>
          </div>
        </Reveal>
      ))}
    </div>
  );
};
